<template>
    <div class="clearfix">
        <compWrapper
            theme="primary"
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
        >
        <compFormEdit
            class="padding-top-15"
            ref="form"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
            :col="1"
        ></compFormEdit>
        </compWrapper>
        <compWrapper
            v-if="querytype == 'query'"
            theme="gray"
            :title="
                $t('global.common.operation_history', {
                    defaultValue: '操作历史',
                })
            "
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>
        <div v-if="querytype != 'query'" class="margin-15 pull-right">
            <Button class="margin-right-15" type="primary" @click="submit"
                >{{$t('global.common.save', { defaultValue: '保存' })}}</Button
            >
            <Button type="default" @click="$emit('on-close')">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpWarehouseCarrierOne,
    HttpSaveWarehouseCarrier,
    HttpOtherLogiServiceList,
    HttpTruckServiceList,
    HttpWarehouseCarrierLog
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
import mixin from '../mixin';
export default {
    mixins: [mixin],
    props: ["activeid", "querytype"],
    data() {
        return {
            formData: {
            },
            newcarrierServiceList: [],
            loading: false,
            truckCarrierGroupList:[],
            logList: [],
            regionId:'',
        };
    },
    created() {
        this.getCarrierService();
        if (this.querytype !== "add") {
            this.getDetail();
            this.getLog();
        }
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            'getCustomServiceProductActiceList',
        ]),
        getBase() {
            return [

                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'warehouseId',
                    tag: 'vSelect',
                    options: this.getBillcusWareList,
                    query: this.querytype !== "add",
                    props:{
                        filterable: true,
                    },
                    on:{
                        'on-change':(val)=>{
                            this.getRegion(val)
                        }
                    },
                },
                // {
                //     label: this.$t('fbb.carrieraccount.carrier_group', { defaultValue: '物流产品' }),
                //     key: "groupId",
                //     tag: "vSelect",
                //     options: this.truckCarrierGroupList,
                //     query: this.querytype !== "add",
                //     on:{
                //         'on-attach':(attach)=>{
                //             console.log(attach)
                //             this.formData.type = attach.type
                //             this.getCarrierService(attach.type)
                //         }
                //     },
                //     valueText:this.formData.groupName
                // },
                {
                    label: this.$t('erp.b2c.hippingMethodCode', { defaultValue: '物流服务' }),
                    key: "carrierServiceId",
                    tag: "vSelect",
                    options: this.getCustomServiceProductActiceList.filter(item=>{
                        if(item.attach.type===0){
                            return item.attach.regionCode===this.regionId
                        }
                        else{
                            return item
                        }
                    }),
                    on:{
                        'on-attach':(attach)=>{
                            this.formData.type = attach.type
                        }
                    },
                    query: this.querytype !== "add",
                    valueText:this.formData.carrierServiceCode+'('+this.formData.carrierServiceName+')'
                },
                {
                    label: '仓库服务代码',
                    key: 'carrierServiceApiCode',
                    tag: 'vInput',
                    // query: false,
                    required: false,
                    query: this.querytype == 'query'
                }
            ];
        },
    },
    methods: {
        getRegion(val){
            const selectWareHouse= this.getBillcusWareList.filter(item=>item.value===val)[0]
            this.regionId=selectWareHouse.attach.regionId;
        },
        async getCarrierService (type) {
            await HttpTruckServiceList().then(res => {
                this.newcarrierServiceList = res.data.map(item => {
                    return {
                        value: item.id,
                        label: `${item.code}(${item.carrierServiceName})`,
                        attach:{
                            type:item.type,
                            ...item
                        }
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
        },

        async getDetail() {
            this.loading = true;
            await HttpWarehouseCarrierOne({
                id: this.activeid,
            }).then(
                (res) => {
                    this.formData = res.data;
                    if(res.data.type == 'EXPRESS'){
                        this.formData.type = 1
                    }else{
                        this.formData.type = 0
                    }
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );

            this.loading = false;
        },
        async getLog () {
            await HttpWarehouseCarrierLog({
                id: this.activeid
            }).then(res => {
                this.logList = res.data.orderLogList || [];
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        async submit() {
            let flag = await this.$refs.form.validate();
            if (!flag) return;
            if (String(this.formData.volumeWeight).indexOf('.') !== -1) {
                return this.$VMessage.error(this.$t('fbb.carrieraccount.carrier_volume_not_float', { defaultValue: '体积重系数只能为正整数' }));
            }
            this.loading = true;
            await HttpSaveWarehouseCarrier({
                id: this.activeid,
                ...this.formData,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$emit("on-update");
                    this.$emit("on-close");
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
    },
};
</script>

<style>
</style>
